export const APP_NAME = "Logistic Admin";

export const API_URL = window.API_URL;

export const ASSETS_URL = process.env.PUBLIC_URL;
export const GG_API_KEY = "AIzaSyALt5mIBGJi3kB-pZR7TSq0GrXZucSo7-c";
export const GG_API_URL = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${GG_API_KEY}&libraries=geometry,drawing,places&language=vi&region=VN`;
